import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

const ScreenReaderMsg = () => {
  const attributes = useSelector((state) => state.Notifications.srAttributes);
  const { ariaLabel, ariaLabelledby, ariaDescribedby, text } = attributes;
  const srRef = useRef();

  useEffect(() => {
    srRef.current.focus();
  }, [attributes]);

  return (
    <div
      tabIndex="-1"
      role="status"
      aria-live="polite"
      ref={srRef}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      aria-describedby={ariaDescribedby}
      className="sr-only no-focus">
      {text}
    </div>
  );
};

export default ScreenReaderMsg;
